<div class="column-centering">

  <div class="card primary dark custom-size margin-large padding-top-large padding-bottom-large position-center">     

      <div>
        <mat-form-field appearance="outline">
          <mat-label>Company</mat-label>
          <input type="text"
                 placeholder="Pick one"
                 aria-label="Company"
                 matInput
                 [formControl]="companyNameControl"
                 [matAutocomplete]="auto"
                 (keydown.enter)="$event.preventDefault()">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCompany" (optionSelected)="null">
            @for (company of companies; track company) {
              <mat-option inViewport (inViewportAction)="inViewportAction($event, company)" [value]="company">{{company.name}}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        <button type="button" (click)="companySelection()" [disabled]="!this.companyNameControl.value">Select Company</button>
      </div>



  </div>
</div>